import { serializeFiles } from "../../../../../../utils/serializeFiles";

export const serializeContractFile = (file) => {
  const [serializedFile] = serializeFiles([file]);
  return serializedFile;
};